import styled from 'styled-components';

export const AgentHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
`;

export default AgentHeader;
